//Slider1
(function () {
    var slider1 = new Swiper('.slider1', {
        effect: 'fade',
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        scrollbar: {
            el: '.swiper-scrollbar',
        },
    });
}());
//Slider2
(function () {
    var slider2 = new Swiper('.slider2', {
        effect: 'fade',
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        scrollbar: {
            el: '.swiper-scrollbar',
        },
    });
}());
//Slider3
(function () {
    var slider3 = new Swiper('.slider3', {
        effect: 'fade',
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        scrollbar: {
            el: '.swiper-scrollbar',
        },
    });
}());
// スクロールでクラス付与 saidnav
(function () {
    const scrollEvent = function () {
        window.addEventListener("scroll", function () {
            // スクロール量の取得
            let scrollValue = window.pageYOffset;
            // 要素の取得
            let scrollEle = document.querySelectorAll("#main");
            // 画面の高さを取得
            let windowHeight = window.innerHeight;
            // はみ出させる値（お好みで設定）
            let targetElement = document.getElementById("main");
            let clientRect = targetElement.getBoundingClientRect();
            let value = window.pageYOffset + clientRect.top;
            // 条件設定
            for (let a = 0; a < scrollEle.length; a++) {
                // 取得した要素のtop値の取得 + スクロール量
                let scrollTop = scrollEle[a].getBoundingClientRect().top + scrollValue;
                if (scrollValue > value) {
                    document.getElementById('SideNav').classList.add("js-fade-in");
                } else {
                    document.getElementById('SideNav').classList.remove("js-fade-in");
                }
            }
        });
    };
    scrollEvent();
}());

// スクロールでクラス付与 svg
(function () {
    const scrollEvent2 = function () {
        window.addEventListener("scroll", function () {
            // スクロール量の取得
            let scrollValue = window.pageYOffset;
            // 要素の取得
            let scrollEle = document.querySelectorAll("svg");
            // 画面の高さを取得
            let windowHeight = window.innerHeight;
            // はみ出させる値（お好みで設定）
            let value = 100;
            // 条件設定
            for (let a = 0; a < scrollEle.length; a++) {
                // 取得した要素のtop値の取得 + スクロール量
                let scrollTop = scrollEle[a].getBoundingClientRect().top + scrollValue;
                if (scrollValue > scrollTop - windowHeight + value) {
                    scrollEle[a].classList.add("animate-active");
                } else {
                    scrollEle[a].classList.remove("animate-active");
                }
            }
        });
    };
    scrollEvent2();
    }());
// スムーススクロール
(function () {
    const smoothScrollTrigger = document.querySelectorAll('a[href^="#"]');
    for (let i = 0; i < smoothScrollTrigger.length; i++) {
        smoothScrollTrigger[i].addEventListener('click', (e) => {
            e.preventDefault();
            let href = smoothScrollTrigger[i].getAttribute('href');
            let targetElement = document.getElementById(href.replace('#', ''));
            const rect = targetElement.getBoundingClientRect().top;
            const offset = window.pageYOffset;
            const gap = 60;
            const target = rect + offset - gap;
            window.scrollTo({
                top: target,
                behavior: 'smooth',
            });
        });
    }
}());
// トップページ
(function () {
    //ボタン
    const scroll_to_top_btn = document.querySelector('#scroll-top');
    //クリックイベントを追加
    scroll_to_top_btn.addEventListener('click', scroll_to_top);
    function scroll_to_top() {
        window.scroll({ top: 0, behavior: 'smooth' });
    };
    //スクロール時のイベントを追加
    window.addEventListener('scroll', scroll_event);
    function scroll_event() {
        if (window.pageYOffset > 400) {
            scroll_to_top_btn.style.opacity = '1';
        } else if (window.pageYOffset < 400) {
            scroll_to_top_btn.style.opacity = '0';
        }
    };
}());